import { render, staticRenderFns } from "./EditLiveDocumentTab.vue?vue&type=template&id=61d347b8"
import script from "./EditLiveDocumentTab.vue?vue&type=script&lang=js"
export * from "./EditLiveDocumentTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports